import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lean_select2',
  templateUrl: './lean_select2.component.html',
  styleUrls: ['./lean_select2.component.scss']
})
export class LeanSelect2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
